import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '../store/store'
import CartDrawer from "./CartDrawer.jsx"
import { setCart } from '../store/cartSlice'

document.addEventListener('DOMContentLoaded', () => {
  store.dispatch(setCart(window.initialCart))
  
  const cartDrawerWrapper = document.querySelector('[data-cart-drawer]')
  const cartProps = JSON.parse(cartDrawerWrapper.getAttribute('props'))
  const cartDrawerRoot = createRoot(cartDrawerWrapper)
  cartDrawerRoot.render(
    <Provider store={store}>
      <CartDrawer data={cartProps} />
    </Provider>)
})